import { render } from "./GTA.vue?vue&type=template&id=7cc88146"
import script from "./GTA.vue?vue&type=script&lang=js"
export * from "./GTA.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__